import { MINIAPP_PACKAGE_ID } from '@/consts/configs';
import { UPLOAD_URL } from '@/consts/urls';

const TEMP_UPLOAD_URL = `${UPLOAD_URL}/v2/files`;
const TEMP_BUCKET = 'genai-temp';

/**
 * Uploads without a user token into the short-lived bucket gen-ai web uses for
 * signed-out uploads. Preview only — the real upload still goes through
 * `uploadToCDN` once the user signs in.
 */
const uploadToTempCDN = async (file: File): Promise<string> => {
  const body = new FormData();
  body.append('type', TEMP_BUCKET);
  body.append('file', file);

  const response = await fetch(TEMP_UPLOAD_URL, {
    method: 'POST',
    headers: { 'x-touchpoint': MINIAPP_PACKAGE_ID },
    body,
  });
  if (!response.ok) {
    throw new Error(`Temp CDN upload failed with status ${response.status}`);
  }

  const { response: result } = await response.json();
  const url = result?.download_url;
  if (!url) {
    throw new Error('Temp CDN upload response is missing a download URL');
  }

  return url;
};

export default uploadToTempCDN;
